(ns ui.view.transaction-process.components.navigation
  "Shared navigation for the TP detail view. Leaving back to the list is guarded
   by the confirmation modal when there are unsaved changes — never
   js/window.confirm."
  (:require
   [common.localization :refer [tr]]
   [frontend.routing :as routing]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]))

(defn leave-to-list!
  "Navigate back to the transaction-process list. With unsaved changes, confirm
   first via the confirmation modal; otherwise leave straight away."
  [dirty?]
  (let [go! (fn [] (routing/set-view! [:transaction-processes-grid]))]
    (if dirty?
      (modals/open-modal!
       confirmation/modal-key
       {:title          (tr :transaction-process/unsaved-changes)
        :body           (tr :transaction-process/leave-unsaved-body)
        :confirm-text   (tr :transaction-process/leave-anyway)
        :skip-checkbox? true
        :on-confirm     go!})
      (go!))))
